export default "__VITE_ASSET__65fa593f__"